import {
  DEFAULT_CURRENCY,
  cherrySymbolImg,
  goldNuggetSymbolImg,
  jackpotCrownSymbolImg,
  kunduDrumSymbolImg,
  kumulBirdSymbolImg,
  kinaShellSymbolImg,
  autobetLogoPngImg,
  polCoinSymbolImg,
  diamondSymbolImg,
  btcCoinSymbolImg,
  lucky7SymbolImg,
  jackpotOrbSymbolImg,
  ethCrystalSymbolImg,
  autobetLogoCryptoImg,
} from "../../../../../static/Constants";
import { colors, borderRadiusPx, customShadows, FIVESLOT_COLOR_THEME } from "../../../../../theme";

/**
 * 5-Slot Detail Page Theme & Layout Config (Centralized Tokens)
 */
export const FIVE_SLOT_DETAILS_THEME = {
  pageBg: colors.dashboard.canvas,
  cardMaxWidth: 590,
  containerMaxWidth: "lg",
  headerBorderRadius: borderRadiusPx.xl,
  machineBorderRadius: borderRadiusPx.xxl,
  shadow: customShadows.card,
  hoverShadow: customShadows.cardHover,
  colorTheme: FIVESLOT_COLOR_THEME,
};

/**
 * Centralized Progressive Jackpot Tier Themes (Mega, Major, Mini)
 */
export const JACKPOT_TIER_THEMES = {
  mega: {
    id: "mega",
    label: "👑 MEGA JACKPOT",
    background: "linear-gradient(180deg, #7f1d1d 0%, #450a0a 100%)",
    border: "1.5px solid #ef4444",
    borderColor: "#ef4444",
    boxShadow: "0 2px 8px rgba(239, 68, 68, 0.3)",
    titleColor: "#fca5a5",
    valueColor: "#fef08a",
    borderRadius: borderRadiusPx.md || "10px",
  },
  major: {
    id: "major",
    label: "💎 MAJOR JACKPOT",
    background: "linear-gradient(180deg, #581c87 0%, #3b0764 100%)",
    border: "1.5px solid #c084fc",
    borderColor: "#c084fc",
    boxShadow: "0 2px 8px rgba(192, 132, 252, 0.3)",
    titleColor: "#e9d5ff",
    valueColor: "#fef08a",
    borderRadius: borderRadiusPx.md || "10px",
  },
  mini: {
    id: "mini",
    label: "🍒 MINI JACKPOT",
    background: "linear-gradient(180deg, #064e3b 0%, #022c22 100%)",
    border: "1.5px solid #4ade80",
    borderColor: "#4ade80",
    boxShadow: "0 2px 8px rgba(74, 222, 128, 0.3)",
    titleColor: "#bbf7d0",
    valueColor: "#fef08a",
    borderRadius: borderRadiusPx.md || "10px",
  },
};

/**
 * Side Badge Numbers with Casino Neon Colors
 */
export const SIDE_BADGES = [
  { num: "4", color: colors.red[500] || "#ef4444" },
  { num: "2", color: colors.blue[500] || "#3b82f6" },
  { num: "9", color: colors.emerald[500] || "#22c55e" },
  { num: "6", color: colors.amber[500] || "#eab308" },
  { num: "1", color: colors.purple[500] || "#a855f7" },
  { num: "7", color: "#f97316" },
  { num: "8", color: colors.cyan[500] || "#06b6d4" },
  { num: "3", color: "#ec4899" },
  { num: "5", color: colors.blue[500] || "#3b82f6" },
];

/**
 * Slot Machine Arcade Frame Theme Tokens
 */
export const SLOT_MACHINE_FRAME_THEME = {
  bg: "#080d1a",
  headerBg: "#0b1220",
  border: "2px solid rgba(234, 179, 8, 0.5)",
  boxShadow: "0 10px 40px rgba(0, 0, 0, 0.8), 0 0 30px rgba(234, 179, 8, 0.2)",
  borderRadius: { xs: borderRadiusPx.lg || "16px", sm: borderRadiusPx.xxl || "24px" },
  headerBorderRadius: borderRadiusPx.md || "8px",
  goldBorder: "rgba(234, 179, 8, 0.5)",
  goldText: "#fef08a",
  amberAccent: "#f59e0b",
};

/**
 * 5-SlotBET Pokies Game Configuration
 * Fiat & Crypto 5-Symbol Editions (Contract Mapped 0..4)
 */
export const FIVE_SLOT_CONFIG = {
  name: "5-SlotBET",
  subtitle: "5-REEL PROGRESSIVE POKIES",
  reels: 5,
  rows: 3,
  paylines: 1,
  paylineDescription: "Match 3 or more symbols left-to-right on the center payline to win!",
  initialReels: ["cherry", "gold_nugget", "jackpot_crown", "kundu_drum", "kumul_bird"],
  defaultBet: 5.0,
  minBet: 1.0,
  maxBet: 500.0,
  betSteps: [1, 2, 5, 10, 25, 50, 100, 250, 500],
  currencySymbol: "BET",
  currencyName: "BET",
};

export const JACKPOT_DEFAULTS = {
  mega: 128900.0,
  major: 16450.0,
  mini: 2840.5,
};

export const THEME_OPTIONS = [
  {
    id: "fiat",
    label: "Fiat 5-Reel Pokies",
    description: "Fiat symbols: Cherry (Mini), Gold Nugget (Major), Crown (Mega), Drum (Free Spins), Kumul Bird (Super Spins)",
  },
  {
    id: "crypto",
    label: "Crypto 5-Reel Pokies",
    description: "Crypto symbols: POL (Mini), Diamond (Major), BTC (Mega), Lucky 7 (Free Spins), Jackpot Orb (Super Spins)",
  },
];

/**
 * FIAT Pokies 5-Symbol Set (Contract Mapped 0 to 4)
 */
export const FIAT_SET_SYMBOLS = [
  {
    contractNumber: 0,
    id: "cherry",
    label: "Cherry",
    winningTier: "Mini Jackpot",
    winOutcome: "Mini Bet / Mini Jackpot",
    code: "CHERRY",
    symbolText: "🍒",
    iconText: "🍒",
    multiplier: 10,
    tier: "Mini Jackpot",
    tierColor: "#10b981",
    color: "#ef4444",
    type: "fiat",
    category: "fiat",
    image: cherrySymbolImg,
    payout: "Mini Jackpot (5x = Mini Jackpot, 4x = 25x, 3x = 10x)",
    description: "Match 5 Cherries to trigger the Mini Progressive Jackpot pool!",
  },
  {
    contractNumber: 1,
    id: "gold_nugget",
    label: "Gold Nugget",
    winningTier: "Major Jackpot",
    winOutcome: "Major Jackpot",
    code: "GOLD",
    symbolText: "🪙",
    iconText: "🪙",
    multiplier: 30,
    tier: "Major Jackpot",
    tierColor: "#3b82f6",
    color: "#3b82f6",
    type: "fiat",
    category: "fiat",
    image: goldNuggetSymbolImg,
    payout: "Major Jackpot (5x = Major Jackpot, 4x = 50x, 3x = 20x)",
    description: "Match 5 Gold Nuggets to trigger the Major Progressive Jackpot pool!",
  },
  {
    contractNumber: 2,
    id: "jackpot_crown",
    label: "Royal Crown",
    winningTier: "Mega Jackpot",
    winOutcome: "Mega Jackpot",
    code: "CROWN",
    symbolText: "👑",
    iconText: "👑",
    multiplier: 50,
    tier: "Mega Jackpot",
    tierColor: "#f59e0b",
    color: "#d97706",
    type: "fiat",
    category: "fiat",
    image: jackpotCrownSymbolImg,
    payout: "Mega Jackpot (5x = Grand Mega Jackpot, 4x = 100x, 3x = 35x)",
    description: "Match 5 Crowns to trigger the Grand Mega Progressive Jackpot pool!",
  },
  {
    contractNumber: 3,
    id: "kundu_drum",
    label: "Kundu Drum",
    winningTier: "Free Spins",
    winOutcome: "5-15 Free Spins",
    code: "DRUM",
    symbolText: "🪘",
    iconText: "🪘",
    multiplier: 15,
    tier: "Free Spins",
    tierColor: "#8b5cf6",
    color: "#8b5cf6",
    type: "fiat",
    category: "fiat",
    image: kunduDrumSymbolImg,
    payout: "5x = 15 Spins + 50x, 4x = 10 Spins + 25x, 3x = 5 Spins",
    description: "Match Kundu Drums to trigger Free Spins Bonus Rounds with multipliers!",
  },
  {
    contractNumber: 4,
    id: "kumul_bird",
    label: "Kumul Bird",
    winningTier: "Super Spins",
    winOutcome: "10-25 Super Spins (2x)",
    code: "BIRD",
    symbolText: "🦅",
    iconText: "🦅",
    multiplier: 25,
    tier: "Super Spins",
    tierColor: "#dc2626",
    color: "#dc2626",
    type: "fiat",
    category: "fiat",
    image: kumulBirdSymbolImg,
    payout: "5x = 25 Super Spins (2x) + 100x, 4x = 15 Super Spins, 3x = 8 Super Spins",
    description: "Match Kumul Birds for Super Free Spins + 2x Win Multiplier boost!",
  },
  {
    contractNumber: 5,
    id: "kina_shell",
    label: "Kina Shell",
    winningTier: "High Value",
    winOutcome: "20x - 50x Win",
    code: "SHELL",
    symbolText: "🐚",
    iconText: "🐚",
    multiplier: 20,
    tier: "High Value",
    tierColor: "#06b6d4",
    color: "#0891b2",
    type: "fiat",
    category: "fiat",
    image: kinaShellSymbolImg,
    payout: "5x = 50x, 4x = 25x, 3x = 10x",
    description: "Match Kina Shells for traditional PNG currency multipliers!",
  },
  {
    contractNumber: 6,
    id: "autobet_logo",
    label: "AutoBET Logo",
    winningTier: "Top Symbol",
    winOutcome: "Top Symbol (35x - 75x)",
    code: "AUTOBET",
    symbolText: "🅰️",
    iconText: "🅰️",
    multiplier: 35,
    tier: "Top Symbol",
    tierColor: "#ec4899",
    color: "#db2777",
    type: "fiat",
    category: "fiat",
    image: autobetLogoPngImg,
    payout: "5x = 75x, 4x = 35x, 3x = 15x",
    description: "AutoBET Logo top payout symbol across all 5 reels!",
  },
];

/**
 * CRYPTO Pokies 7-Symbol Set (Contract Mapped 0 to 6)
 */
export const CRYPTO_SET_SYMBOLS = [
  {
    contractNumber: 0,
    id: "pol",
    label: "Polygon POL",
    winningTier: "Mini Jackpot",
    winOutcome: "Mini Bet / Mini Jackpot",
    code: "POL",
    symbolText: "🟣",
    iconText: "🟣",
    multiplier: 10,
    tier: "Mini Jackpot",
    tierColor: "#10b981",
    color: "#10b981",
    type: "crypto",
    category: "crypto",
    image: polCoinSymbolImg,
    payout: "Mini Jackpot (5x = Mini Jackpot, 4x = 25x, 3x = 10x)",
    description: "Match 5 POL to trigger the Mini Progressive Jackpot pool!",
  },
  {
    contractNumber: 1,
    id: "diamond",
    label: "Diamond",
    winningTier: "Major Jackpot",
    winOutcome: "Major Jackpot",
    code: "DIAMOND",
    symbolText: "💎",
    iconText: "💎",
    multiplier: 30,
    tier: "Major Jackpot",
    tierColor: "#3b82f6",
    color: "#3b82f6",
    type: "crypto",
    category: "crypto",
    image: diamondSymbolImg,
    payout: "Major Jackpot (5x = Major Jackpot, 4x = 50x, 3x = 20x)",
    description: "Match 5 Diamonds to trigger the Major Progressive Jackpot pool!",
  },
  {
    contractNumber: 2,
    id: "btc",
    label: "Bitcoin BTC",
    winningTier: "Mega Jackpot",
    winOutcome: "Mega Jackpot",
    code: "BTC",
    symbolText: "₿",
    iconText: "₿",
    multiplier: 50,
    tier: "Mega Jackpot",
    tierColor: "#f59e0b",
    color: "#d97706",
    type: "crypto",
    category: "crypto",
    image: btcCoinSymbolImg,
    payout: "Mega Jackpot (5x = Grand Mega Jackpot, 4x = 100x, 3x = 35x)",
    description: "Match 5 Bitcoins to trigger the Grand Mega Progressive Jackpot pool!",
  },
  {
    contractNumber: 3,
    id: "lucky_7",
    label: "Lucky 7",
    winningTier: "Free Spins",
    winOutcome: "5-15 Free Spins",
    code: "SEVEN",
    symbolText: "7️⃣",
    iconText: "7️⃣",
    multiplier: 15,
    tier: "Free Spins",
    tierColor: "#8b5cf6",
    color: "#8b5cf6",
    type: "crypto",
    category: "crypto",
    image: lucky7SymbolImg,
    payout: "5x = 15 Spins + 50x, 4x = 10 Spins + 25x, 3x = 5 Spins",
    description: "Match 3+ Lucky 7s to trigger Web3 Free Spins Bonus Round!",
  },
  {
    contractNumber: 4,
    id: "jackpot_orb",
    label: "Jackpot Orb",
    winningTier: "Super Spins",
    winOutcome: "10-25 Super Spins (2x)",
    code: "ORB",
    symbolText: "🔮",
    iconText: "🔮",
    multiplier: 25,
    tier: "Super Spins",
    tierColor: "#dc2626",
    color: "#dc2626",
    type: "crypto",
    category: "crypto",
    image: jackpotOrbSymbolImg,
    payout: "5x = 25 Super Spins (2x) + 100x, 4x = 15 Super Spins, 3x = 8 Super Spins",
    description: "Match 3+ Jackpot Orbs for Super Free Spins + 2x Win Multipliers!",
  },
  {
    contractNumber: 5,
    id: "eth_crystal",
    label: "ETH Crystal",
    winningTier: "High Value",
    winOutcome: "20x - 50x Win",
    code: "ETH",
    symbolText: "💎",
    iconText: "💎",
    multiplier: 20,
    tier: "High Value",
    tierColor: "#06b6d4",
    color: "#0891b2",
    type: "crypto",
    category: "crypto",
    image: ethCrystalSymbolImg,
    payout: "5x = 50x, 4x = 25x, 3x = 10x",
    description: "Match Ethereum crystals for high-yield Web3 rewards!",
  },
  {
    contractNumber: 6,
    id: "autobet_logo_crypto",
    label: "AutoBET Logo",
    winningTier: "Top Symbol",
    winOutcome: "Top Symbol (35x - 75x)",
    code: "AUTOBET",
    symbolText: "🅰️",
    iconText: "🅰️",
    multiplier: 35,
    tier: "Top Symbol",
    tierColor: "#ec4899",
    color: "#db2777",
    type: "crypto",
    category: "crypto",
    image: autobetLogoCryptoImg,
    payout: "5x = 75x, 4x = 35x, 3x = 15x",
    description: "AutoBET Logo top payout symbol across all 5 reels!",
  },
];

export const ALL_SYMBOLS = [...FIAT_SET_SYMBOLS, ...CRYPTO_SET_SYMBOLS];
export const SYMBOLS = ALL_SYMBOLS;

export const DUMMY_BET_CURRENCY = "BET";
export const REEL_COUNT = 5;
export const VISIBLE_ROWS = 3;
export const REEL_STOP_TIMES = [700, 1100, 1500, 1900, 2300];
export const SPIN_TICK_MS = 80;

/**
 * Helper to get the 5 symbols mapped from 0 to 4 based on Fiat or Crypto category
 */
export const getSymbolsByCategory = (category = "fiat") => {
  if (category === "crypto") {
    return CRYPTO_SET_SYMBOLS;
  }
  return FIAT_SET_SYMBOLS;
};

export const getSymbolsByTheme = (themeName = "fiat") => {
  return getSymbolsByCategory(themeName);
};

export const getRandomSymbol = (category = "fiat") => {
  const symbolSet = getSymbolsByCategory(category);
  const randomIndex = Math.floor(Math.random() * symbolSet.length);
  return symbolSet[randomIndex] || symbolSet[0];
};

export const getSymbolById = (id) => {
  return ALL_SYMBOLS.find((symbol) => symbol.id === id) || FIAT_SET_SYMBOLS[0];
};

/**
 * Determine winning payout and jackpot status for 5-Reel Pokies
 * Evaluates center 5 symbols (5-of-a-kind, 4-of-a-kind, 3-of-a-kind left-to-right)
 */
export const calculateWinResult = (
  reels,
  betAmount = 5.0,
  isFreeSpins = false,
  jackpots = JACKPOT_DEFAULTS
) => {
  if (!reels || reels.length !== 5) {
    return { isWin: false, amount: 0, type: "none", label: "No Spin", winningIndices: [] };
  }

  const multiplierMultiplier = isFreeSpins ? 2 : 1; // 2x boost during Free Spins

  // Count consecutive matches from left to right starting at reel 0
  const firstSym = reels[0];
  let consecutiveCount = 1;
  const winningIndices = [0];

  for (let i = 1; i < reels.length; i++) {
    const sym = reels[i];
    const isMatch =
      (firstSym.contractNumber !== undefined && firstSym.contractNumber === sym.contractNumber) ||
      (firstSym.id && firstSym.id === sym.id);

    if (isMatch) {
      consecutiveCount++;
      winningIndices.push(i);
    } else {
      break;
    }
  }

  // Also check if any other 3-of-a-kind or 4-of-a-kind exists across the 5 reels if left-to-right is < 3
  if (consecutiveCount < 3) {
    // Check frequency count
    const counts = {};
    reels.forEach((r, idx) => {
      const key = r.id;
      if (!counts[key]) counts[key] = { count: 0, sym: r, indices: [] };
      counts[key].count++;
      counts[key].indices.push(idx);
    });

    let bestKey = null;
    let maxFreq = 0;
    Object.keys(counts).forEach((k) => {
      if (counts[k].count > maxFreq) {
        maxFreq = counts[k].count;
        bestKey = k;
      }
    });

    if (maxFreq >= 3) {
      const best = counts[bestKey];
      return evaluateMatchCount(best.sym, maxFreq, betAmount, multiplierMultiplier, jackpots, best.indices);
    }

    return {
      isWin: false,
      amount: 0,
      type: "loss",
      jackpotTier: null,
      label: "No Match",
      winningIndices: [],
    };
  }

  return evaluateMatchCount(firstSym, consecutiveCount, betAmount, multiplierMultiplier, jackpots, winningIndices);
};

function evaluateMatchCount(symbol, count, betAmount, multiplierMultiplier, jackpots, winningIndices) {
  const symId = symbol.id;
  const contractNum = symbol.contractNumber;

  // 1. 5-OF-A-KIND (TOP JACKPOTS & MAX BONUSES)
  if (count === 5) {
    // MEGA JACKPOT (Crown / BTC)
    if (contractNum === 2 || symId === "jackpot_crown" || symId === "btc") {
      const winAmt = jackpots?.mega && jackpots.mega > 0 ? jackpots.mega : betAmount * 500 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "jackpot",
        jackpotTier: "mega",
        matchCount: 5,
        label: "👑 MEGA JACKPOT (5x)!",
        symbol,
        winningIndices,
      };
    }

    // MAJOR JACKPOT (Gold / Diamond)
    if (contractNum === 1 || symId === "gold_nugget" || symId === "diamond") {
      const winAmt = jackpots?.major && jackpots.major > 0 ? jackpots.major : betAmount * 250 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "jackpot",
        jackpotTier: "major",
        matchCount: 5,
        label: "💎 MAJOR JACKPOT (5x)!",
        symbol,
        winningIndices,
      };
    }

    // MINI JACKPOT (Cherry / POL)
    if (contractNum === 0 || symId === "cherry" || symId === "pol") {
      const winAmt = jackpots?.mini && jackpots.mini > 0 ? jackpots.mini : betAmount * 100 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "jackpot",
        jackpotTier: "mini",
        matchCount: 5,
        label: "🍒 MINI JACKPOT (5x)!",
        symbol,
        winningIndices,
      };
    }

    // 15 Free Spins (Drum / Lucky 7)
    if (contractNum === 3 || symId === "kundu_drum" || symId === "lucky_7") {
      const winAmt = betAmount * 50 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "freespins",
        freeSpinsWon: 15,
        matchCount: 5,
        label: "15 FREE SPINS + 50X!",
        jackpotTier: null,
        symbol,
        winningIndices,
      };
    }

    // 25 Super Spins (Kumul / Orb)
    if (contractNum === 4 || symId === "kumul_bird" || symId === "jackpot_orb") {
      const winAmt = betAmount * 100 * 2 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "freespins",
        freeSpinsWon: 25,
        matchCount: 5,
        label: "25 SUPER SPINS (2X WIN) + 100X!",
        jackpotTier: null,
        symbol,
        winningIndices,
      };
    }
  }

  // 2. 4-OF-A-KIND (TIER 2 WINS)
  if (count === 4) {
    if (contractNum === 2 || symId === "jackpot_crown" || symId === "btc") {
      const winAmt = betAmount * 75 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "match4",
        jackpotTier: null,
        matchCount: 4,
        label: `4x ${symbol.label.toUpperCase()} (75X WIN)`,
        symbol,
        winningIndices,
      };
    }

    if (contractNum === 1 || symId === "gold_nugget" || symId === "diamond") {
      const winAmt = betAmount * 50 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "match4",
        jackpotTier: null,
        matchCount: 4,
        label: `4x ${symbol.label.toUpperCase()} (50X WIN)`,
        symbol,
        winningIndices,
      };
    }

    if (contractNum === 0 || symId === "cherry" || symId === "pol") {
      const winAmt = betAmount * 25 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "match4",
        jackpotTier: null,
        matchCount: 4,
        label: `4x ${symbol.label.toUpperCase()} (25X WIN)`,
        symbol,
        winningIndices,
      };
    }

    if (contractNum === 3 || symId === "kundu_drum" || symId === "lucky_7") {
      const winAmt = betAmount * 25 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "freespins",
        freeSpinsWon: 10,
        matchCount: 4,
        label: "10 FREE SPINS + 25X!",
        jackpotTier: null,
        symbol,
        winningIndices,
      };
    }

    if (contractNum === 4 || symId === "kumul_bird" || symId === "jackpot_orb") {
      const winAmt = betAmount * 50 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "freespins",
        freeSpinsWon: 15,
        matchCount: 4,
        label: "15 SUPER SPINS (2X WIN) + 50X!",
        jackpotTier: null,
        symbol,
        winningIndices,
      };
    }
  }

  // 3. 3-OF-A-KIND (TIER 3 WINS)
  if (count === 3) {
    if (contractNum === 2 || symId === "jackpot_crown" || symId === "btc") {
      const winAmt = betAmount * 25 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "match3",
        jackpotTier: null,
        matchCount: 3,
        label: `3x ${symbol.label.toUpperCase()} (25X)`,
        symbol,
        winningIndices,
      };
    }

    if (contractNum === 1 || symId === "gold_nugget" || symId === "diamond") {
      const winAmt = betAmount * 15 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "match3",
        jackpotTier: null,
        matchCount: 3,
        label: `3x ${symbol.label.toUpperCase()} (15X)`,
        symbol,
        winningIndices,
      };
    }

    if (contractNum === 0 || symId === "cherry" || symId === "pol") {
      const winAmt = betAmount * 10 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "match3",
        jackpotTier: null,
        matchCount: 3,
        label: `3x ${symbol.label.toUpperCase()} (10X)`,
        symbol,
        winningIndices,
      };
    }

    if (contractNum === 3 || symId === "kundu_drum" || symId === "lucky_7") {
      const winAmt = betAmount * 10 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "freespins",
        freeSpinsWon: 5,
        matchCount: 3,
        label: "5 FREE SPINS + 10X!",
        jackpotTier: null,
        symbol,
        winningIndices,
      };
    }

    if (contractNum === 4 || symId === "kumul_bird" || symId === "jackpot_orb") {
      const winAmt = betAmount * 20 * multiplierMultiplier;
      return {
        isWin: true,
        amount: winAmt,
        type: "freespins",
        freeSpinsWon: 8,
        matchCount: 3,
        label: "8 SUPER SPINS (2X WIN) + 20X!",
        jackpotTier: null,
        symbol,
        winningIndices,
      };
    }

    // Default 3x
    const winAmt = betAmount * (symbol.multiplier || 10) * multiplierMultiplier;
    return {
      isWin: true,
      amount: winAmt,
      type: "match3",
      jackpotTier: null,
      matchCount: 3,
      label: `3x ${symbol.label.toUpperCase()}`,
      symbol,
      winningIndices,
    };
  }

  return {
    isWin: false,
    amount: 0,
    type: "loss",
    jackpotTier: null,
    label: "No Match",
    winningIndices: [],
  };
}
